import React from 'react';
import './EventGallery.css';
import img1 from '../assets/1.png';
import img2 from '../assets/2.png';
import img3 from '../assets/3.png';
import img4 from '../assets/4.png';

const EventGallery = () => {
  const images = [
    { src: img1, alt: 'Convention hall wedding decoration' },
    { src: img2, alt: 'Stage setup with lighting' },
    { src: img3, alt: 'Event hall arrangement' },
    { src: img4, alt: 'Reception area setup' },
    { src: img2, alt: 'Cultural event setup' },
    { src: img3, alt: 'Grand celebration decor' },
  ];

  return (
    <section className="gallery-section" id="gallery">
      <h2 className="section-title">Event Gallery</h2>
      <p className="section-subtitle">
        Take a look at some of our most memorable events
      </p>
      <div className="gallery-grid">
        {images.map((image, index) => (
          <div className="gallery-item" key={index}>
            <img src={image.src} alt={image.alt} loading="lazy" />
          </div>
        ))}
      </div>
    </section>
  );
};

export default EventGallery;
